"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loader = void 0;
const mineflayer_physics_util_1 = require("@nxg-org/mineflayer-physics-util");
const mineflayer_util_plugin_1 = __importDefault(require("@nxg-org/mineflayer-util-plugin"));
const wrapper_1 = require("./wrapper");
function loader(bot) {
    (0, mineflayer_physics_util_1.initSetup)(bot.registry);
    bot.loadPlugin(mineflayer_util_plugin_1.default);
    bot.autoJumper = new wrapper_1.AutoJumper(bot);
}
exports.loader = loader;
